import { supabase } from '../client';

export interface ClientContact {
  id: string;
  org_id: string;
  client_id: string;
  full_name: string;
  title: string | null;
  email: string | null;
  phone: string | null;
  is_primary: boolean;
  notes: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export type ClientContactCreate = Pick<
  ClientContact, 'org_id' | 'client_id' | 'full_name'
> & Partial<Pick<ClientContact, 'title' | 'email' | 'phone' | 'is_primary' | 'notes' | 'created_by'>>;

export const clientContactService = {
  async listByClient(clientId: string): Promise<ClientContact[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_contacts')
      .select('*')
      .eq('client_id', clientId)
      .order('is_primary', { ascending: false })
      .order('full_name');
    if (error) throw error;
    return (data ?? []) as ClientContact[];
  },

  async create(payload: ClientContactCreate): Promise<ClientContact> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_contacts')
      .insert(payload)
      .select()
      .single();
    if (error) throw error;
    return data as ClientContact;
  },

  async update(id: string, payload: Partial<Pick<ClientContact, 'full_name' | 'title' | 'email' | 'phone' | 'is_primary' | 'notes'>>): Promise<ClientContact> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_contacts')
      .update(payload)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data as ClientContact;
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_client_contacts')
      .delete()
      .eq('id', id);
    if (error) throw error;
  },
};
